// extracted by mini-css-extract-plugin
module.exports = {"header":"CollegeCoachEditPage_header__AuL9r"};